import { SceneSlice } from "./store";
import {
  level1Config,
  level2Config,
  level3Config,
  level4Config,
  level5Config,
} from '../../e.elements/scenes/Graveyards/config'

export const SEL_CURRENT_LEVEL_CONFIG = (s: SceneSlice) => {
  const currentLevelId = s.user.currentLevelId
  switch(currentLevelId) {
    case 'level1':
    default:
      return level1Config
    case 'level2':
      return level2Config
    case 'level3':
      return level3Config
    case 'level4':
      return level4Config
    case 'level5':
      return level5Config
  }
}